import {
  intranetAiAgentListSchema,
  type ReplaceIntranetAiAgentsRequest,
} from '@gb-ticket/shared-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';

export const intranetAiAgentsQueryKey = ['intranet', 'ai', 'agents'] as const;

export function useIntranetAiAgents() {
  return useQuery({
    queryKey: intranetAiAgentsQueryKey,
    queryFn: () => apiFetch('/intranet/ai/agents', intranetAiAgentListSchema),
  });
}

export function useReplaceIntranetAiAgents() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: ReplaceIntranetAiAgentsRequest) =>
      apiFetch('/intranet/ai/agents', intranetAiAgentListSchema, {
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: intranetAiAgentsQueryKey });
    },
  });
}
